import React, { useState, useEffect, Fragment } from 'react';
// import { Deck, Slide } from 'spectacle';
import { ThemeProvider } from 'styled-components';
import { Helmet } from 'react-helmet';
import theme from './theme';
import { mergeTheme, oneTheme } from './deckTheme';
import innerPresentationBack from './imgs/02-inner_presentation_junior.png';
import vocationHeaderLogo from './imgs/vocation_junior_horizontal.svg';

import { ResetCSS, GlobalStyle, PageWrapper, PageNumber } from './styles';
// pages
import PresentationPage from './Pages/Presentation';
import InfoDataPage from './Pages/InfoData';
import OrientationDescriptionPage from './Pages/OrientationDescription';
import AreasGraphPage from './Pages/AreasGraph';
import AreasDescriptionPage from './Pages/AreasDescription';
import PreferencesGraphPage from './Pages/PreferencesGraph';
import InterestDescriptionPage from './Pages/InterestDescription';
import InterestGraphPage from './Pages/InterestGraph';
import InterestAreaDescriptionPage from './Pages/InterestAreaDescription';
import DisciplinesGraphPage from './Pages/DisciplinesGraph';
import TopDisciplinesPage from './Pages/TopDisciplines';
import MotivationScalesDescriptionPage from './Pages/MotivationScalesDescription';
import MotivationScalesDescriptionCont from './Pages/MotivationScalesDescriptionCont';
import StrategyScalesDescriptionPage from './Pages/StrategyScalesDescription';
import StrategyScalesDescriptionCont from './Pages/StrategyScalesDescriptionCont';
import ClosingPage from './Pages/ClosingPage';
import CoverPage from './Pages/CoverPage';
import BackCover from './Pages/BackCover';

// ELECTIVOS DATA
import { ELECTIVOS_BASE } from './constants';

const Deck = props => {
  // console.log({ props });
  const style = {
    // position: 'relative',
    // height: `${props.theme.size.height}px`,
    // width: `${props.theme.size.width}px`,
    backgroundColor: props.backgroundColor || '#FFFFFF',
    page: 'single' // css page definition
  };
  return <div style={style}>{props.children}</div>;
};

const Slide = props => {
  const style = {
    position: 'relative',
    display: 'block',
    height: `1123px`,
    width: `794px`,
    marginTop: '-2px',
    backgroundColor: props.backgroundColor || 'transparent',
    overflow: 'hidden'
  };
  return (
    <div className='page' id='single' style={style}>
      {props.children}
    </div>
  );
};

// Slider Deck theme
const deckTheme = mergeTheme(oneTheme);

// https://github.com/FormidableLabs/spectacle/blob/master/docs/content/advanced-concepts.md#query-parameters
// add to url
// &exportMode=true
export const SlidePage = ({ number, children, background, header = true }) => {
  const isEven = number % 2 === 0;
  // console.log({ number, isEven });
  return (
    <PageWrapper backgroundImage={background}>
      {children}
      {header && (
        <div
          style={{
            position: 'absolute',
            top: 85,
            left: 0,
            right: 0,
            marginLeft: 92,
            marginRight: 75
          }}
        >
          <img
            src={vocationHeaderLogo}
            alt='vocation start header'
            style={{ height: 34 }}
          />
          <div
            style={{ height: 4, background: '#5ea763', width: '100%' }}
          ></div>
        </div>
      )}
      {number && <PageNumber even={isEven}>{number}</PageNumber>}
    </PageWrapper>
  );
};

// /vocation-one/u/1xPPbmQNdcpbMHNOoE16Vz5Nx_QiBZHgfYIlISUt1Ku4/padre-hurtado-y-juanita-de-los-andes/21.293.144-6

// vocation-junior
// /vocation-junior/u/1CGuBUZ1v6Tw4YIV_RKvIZJG1Wp70rlmaXFficOIpWW0/liceo-siete-providencia/21.673.962-0

// /r/84af0b5d-5ced-44c5-acda-bd71ae233972
// /r/f90f82aa-d35d-47d6-af69-0cc3825aefd6?exportMode=true&slide=0&slideElement=-1

// http://localhost:3000/r/fa64901d-29fd-45be-8de5-c05d4e413246?slideIndex=0&stepIndex=0

const VocationJunior = ({ campaign, response, data }) => {
  const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(false);
  const [user, setUser] = useState(null);
  // console.log({ props });

  useEffect(() => {
    // console.log({ params });
    const parseUser = async () => {
      const userData = data;
      // // –––– for local  dummy
      // const userData = vocationJuniorDummy;
      // // –––––––––––––––––––––
      const fields = Object.keys(userData);
      const interestAreaFields = ['A', 'B', 'C'];
      const sortedInterestArea = interestAreaFields
        .map(fieldKey => ({
          field: fieldKey,
          value: userData[fieldKey] ? parseFloat(userData[fieldKey]) : 0
        }))
        .sort((a, b) => b.value - a.value);
      const sorted_A = fields
        .filter(field => field.includes('perc_A_'))
        .map(fieldKey => ({
          field: fieldKey,
          area: 'A',
          dimension: fieldKey.split('perc_A_')[1],
          value: userData[fieldKey] ? parseFloat(userData[fieldKey]) : 0
        }))
        .sort((a, b) => b.value - a.value);

      const sorted_B = fields
        .filter(field => field.includes('perc_B_'))
        .map(fieldKey => ({
          field: fieldKey,
          area: 'B',
          dimension: fieldKey.split('perc_B_')[1],
          value: userData[fieldKey] ? parseFloat(userData[fieldKey]) : 0
        }))
        .sort((a, b) => b.value - a.value);
      const sorted_C = fields
        .filter(field => field.includes('perc_C_'))
        .map(fieldKey => ({
          field: fieldKey,
          area: 'C',
          dimension: fieldKey.split('perc_C_')[1],
          value: userData[fieldKey] ? parseFloat(userData[fieldKey]) : 0
        }))
        .sort((a, b) => b.value - a.value);
      const sortedDisp = [...sorted_A, ...sorted_B, ...sorted_C].sort(
        (a, b) => b.value - a.value
      );
      // console.log({ sortedDisp });
      const baseInfo = {
        RUT: userData.rut,
        name: '',
        lastname: '',
        grade: '',
        school: campaign.organization || campaign.title
      };
      const school = userData.school || baseInfo.school;
      const parsedUser = {
        ...baseInfo,
        ...userData,
        school,
        sorted_A,
        sorted_B,
        sorted_C,
        sortedDisp,
        TOP_AREA: sortedInterestArea[0].field,
        createdAt: response.createdAt,
        updatedAt: response.updatedAt,
        responseId: response.id,
        responseAccessKey: response.accessKey
      };
      setUser(parsedUser);
      setLoading(false);
    };
    parseUser();
  }, [data]);

  // console.log({ user });
  if (loading) {
    return <div>loading...</div>;
  }
  const userSchool = user.school ? `_${user.school.split(' ').join('_')}` : '';
  const userGrade = user.grade ? `${user.grade.split(' ').join('_')}_` : '';

  const userElectivos = campaign?.metadata?.electivos || ELECTIVOS_BASE;

  const topDims = [
    user.TOP_DIM_1,
    user.TOP_DIM_2,
    user.TOP_DIM_3,
    user.TOP_DIM_4
  ].filter(Boolean);
  // console.log({ topDims });

  const topDimsLength = topDims.length;
  const halfLength = 4 + topDimsLength;

  return (
    <ThemeProvider theme={theme}>
      <Fragment>
        <Helmet>
          <title>{`${userGrade}${user.RUT}${userSchool}_VocationJunior`}</title>
        </Helmet>
        <ResetCSS />
        <GlobalStyle />
        <Deck theme={deckTheme} backgroundColor='#fff'>
          {/* <Slide backgroundColor='#fff'>
            <JuniorTopPage
              user={user}
              background={topBackground}
              header={false}
            />
          </Slide> */}

          <Slide backgroundColor='#5ea763'>
            <CoverPage user={user} header={false} campaign={campaign} />
          </Slide>

          {/** BLANK PAGE */}
          <Slide backgroundColor='#fff'>
            <SlidePage header={false}></SlidePage>
          </Slide>

          <Slide backgroundColor='#fff'>
            <PresentationPage
              user={user}
              number={1}
              background={innerPresentationBack}
              header={false}
            />
          </Slide>

          <Slide backgroundColor='#fff'>
            <InfoDataPage user={user} number={2} />
          </Slide>

          <Slide backgroundColor='#fff'>
            <OrientationDescriptionPage number={3} />
          </Slide>

          <Slide backgroundColor='#fff'>
            <AreasGraphPage user={user} number={4} />
          </Slide>

          {topDims.map((dim, index) => {
            const isLast = index === topDimsLength - 1;
            return (
              <Slide backgroundColor='#fff' key={`${dim}_${index}`}>
                <AreasDescriptionPage
                  user={user}
                  dim={dim}
                  order={index + 1}
                  number={5 + index}
                  isLast={isLast}
                />
              </Slide>
            );
          })}

          <Slide backgroundColor='#fff'>
            <PreferencesGraphPage user={user} number={halfLength + 1} />
          </Slide>

          <Slide backgroundColor='#fff'>
            <InterestDescriptionPage
              user={user}
              number={halfLength + 2}
              electivos={userElectivos}
            />
          </Slide>

          <Slide backgroundColor='#fff'>
            <InterestGraphPage
              user={user}
              number={halfLength + 3}
              electivos={userElectivos}
              campaign={campaign}
            />
          </Slide>

          <Slide backgroundColor='#fff'>
            <InterestAreaDescriptionPage
              user={user}
              number={halfLength + 4}
              electivos={userElectivos}
              campaign={campaign}
            />
          </Slide>

          <Slide backgroundColor='#fff'>
            <DisciplinesGraphPage
              user={user}
              number={halfLength + 5}
              electivos={userElectivos}
            />
          </Slide>

          <Slide backgroundColor='#fff'>
            <TopDisciplinesPage
              user={user}
              number={halfLength + 6}
              electivos={userElectivos}
            />
          </Slide>

          <Slide backgroundColor='#fff'>
            <MotivationScalesDescriptionPage
              user={user}
              number={halfLength + 7}
            />
          </Slide>
          <Slide backgroundColor='#fff'>
            <MotivationScalesDescriptionCont
              user={user}
              number={halfLength + 8}
            />
          </Slide>

          <Slide backgroundColor='#fff'>
            <StrategyScalesDescriptionPage
              user={user}
              number={halfLength + 9}
            />
          </Slide>
          <Slide backgroundColor='#fff'>
            <StrategyScalesDescriptionCont
              user={user}
              number={halfLength + 10}
            />
          </Slide>

          <Slide backgroundColor='#fff'>
            <ClosingPage number={halfLength + 11} user={user} />
          </Slide>

          {/* <Slide backgroundColor='#fff'>
            <JuniorClosePage background={backBackground} header={false} />
          </Slide> */}
          <Slide backgroundColor='#fff'>
            <BackCover backgroundColor='#fff' header={false} />
          </Slide>
        </Deck>
      </Fragment>
    </ThemeProvider>
  );
};

export default VocationJunior;

// const vocationJuniorDummy = {
//   school: 'Colegio Vocation Junior',
//   grade: '2°A',
//   name: 'Nombre(s)',
//   lastname: 'Apellido(s)',
//   email: '',
//   RUT: '99.999.999-9',
//   BIRTH: '2004/06/09 0:00:00',
//   SEX: 'Femenino',
//   age: '16',
//   updatedat: 'Wed, 18 Nov 2020 18:34:26 GMT',
//   TOP_DIM_1: 'CN',
//   TOP_DIM_2: 'LM',
//   CONS_AL: '-25',
//   CONS_SE: '21.875',
//   CONS_IP: '12.5',
//   CONS_LM: '-15.625',
//   CONS_AP: '25',
//   CONS_CD: '-21.875',
//   CONS_FM: '-12.5',
//   CONS_CN: '15.625',
//   perc_AL_SUM: '18.75',
//   perc_AP_SUM: '43.75',
//   perc_CD_SUM: '37.5',
//   perc_CN_SUM: '87.5',
//   perc_FM_SUM: '34.375',
//   perc_IP_SUM: '46.875',
//   perc_LM_SUM: '71.875',
//   perc_SE_SUM: '59.375',
//   perc_A_F: '50',
//   perc_A_HGC: '44.44444444',
//   perc_A_LL: '50',
//   perc_B_CBS: '100',
//   perc_B_CD: '100',
//   perc_B_M: '61.11111111',
//   perc_C_AI: '0',
//   perc_C_AV: '22.22222222',
//   perc_C_D: '22.22222222',
//   A: '48.14814815',
//   B: '87.03703704',
//   C: '14.81481481'
// };
